import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { RatingModule } from 'primeng/rating';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormArray, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'lib-table-expand-collapse',
  standalone: true,
  imports: [TableModule, TagModule, RatingModule, ButtonModule, CommonModule, FormsModule, InputIconModule, IconFieldModule, ReactiveFormsModule],
  providers: [],
  templateUrl: './table-expand-collapse.component.html',
  styleUrl: './table-expand-collapse.component.css'
})
export class TableExpandCollapseComponent {
  @Input() groupColumnName !: any;
  @Input() header !: any;
  @Input() datasource !: any;
  @Input() submitted : boolean = false;
  @Input() recordForm !: FormGroup;
  @Output() delete: EventEmitter<string> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  expandedRows = {};
  obj: any;
  loader !: boolean;
  constructor(private _loader: LoaderService) {
    this._loader.isLoading.subscribe((res) => this.loader = res)
  }

  public get records():FormArray{
    return <FormArray> this.recordForm.get('record');
  }
  calculatedataTotal(name: string) {
    let total = 0;

    if (this.datasource) {
      for (let customer of this.datasource) {
        if (customer.categoryName === name) {
          total++;
        }
      }
    }

    return total;
  }

  onDelete(id:any) {
    this.delete.emit(id);
  }
  onChange(event:any,index: number, key: any, qty: any) {
    this.records.get([index, key])?.setValue(qty[key])
    this.records.get([index, key])?.markAsTouched();
    this.records.get([index, key])?.markAsDirty();
    this.change.emit({event: event ,key: key, data: qty});
  }
}
